import { Link } from 'react-router-dom';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import Mascot from '@/components/Mascot';
import { ArrowRight, X } from 'lucide-react';

/**
 * Modal di celebrazione post-pubblicazione (annuncio o partita).
 * Giulio festeggia con confetti; mostra 2 CTA: visualizza o torna alla lista.
 *
 * Props:
 *  - open: boolean
 *  - onClose: fn
 *  - title: "Annuncio pubblicato!" / "Partita pubblicata!"
 *  - subtitle: dettaglio
 *  - primaryCta: { label, to } - vedi dettaglio
 *  - secondaryCta: { label, to } - esplora/vai alla lista
 */
export default function PublishSuccessModal({ open, onClose, title, subtitle, primaryCta, secondaryCta }) {
  return (
    <Dialog open={open} onOpenChange={(v)=>{ if(!v) onClose?.(); }}>
      <DialogContent className="max-w-md p-0 overflow-hidden" data-testid="publish-success-modal">
        <div className="relative px-6 pt-8 pb-6 text-center bg-gradient-to-b from-accent/20 to-transparent">
          <button
            onClick={onClose}
            aria-label="Chiudi"
            className="absolute top-3 right-3 w-8 h-8 rounded-full grid place-items-center hover:bg-secondary"
          >
            <X size={14}/>
          </button>
          <div className="flex justify-center">
            <Mascot pose="celebrate" size={200}/>
          </div>
          <div className="mt-4 text-xs uppercase tracking-[0.3em] font-bold text-terracotta">Fantastico!</div>
          <h2 className="mt-2 font-display text-3xl tracking-tighter">{title}</h2>
          {subtitle && <p className="mt-2 text-sm text-muted-foreground max-w-xs mx-auto">{subtitle}</p>}
        </div>
        <div className="p-6 pt-2 flex flex-col gap-2">
          {primaryCta && (
            <Link to={primaryCta.to} onClick={onClose}>
              <Button className="w-full rounded-full h-11" data-testid="success-primary-cta">
                {primaryCta.label} <ArrowRight size={14} className="ml-2"/>
              </Button>
            </Link>
          )}
          {secondaryCta && (
            <Link to={secondaryCta.to} onClick={onClose}>
              <Button variant="outline" className="w-full rounded-full h-11" data-testid="success-secondary-cta">
                {secondaryCta.label}
              </Button>
            </Link>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
